/* tslint:disable */
import { TernarySearchTree } from '@vscode/base-node/vs/base/common/map';
import {
    IConfigurationService, IConfigurationData, IConfigurationOverrides,
} from '../interfaces';
import { getConfigurationValue, isConfigurationOverrides, getConfigurationKeys } from '../utils';
import { injectable } from 'inversify';
import { URI } from '@vscode/base-node/vs/base/common/uri';

@injectable()
export class TestConfigurationService implements IConfigurationService {
    public _serviceBrand: any;

    private configuration = Object.create(null);

    private configurationByRoot: TernarySearchTree<any> = TernarySearchTree.forPaths<any>();

    public reloadConfiguration<T>(): Promise<T> {
        return Promise.resolve(this.getValue());
    }

    public getValue(arg1?: any, arg2?: any): any {
        let configuration;
        const overrides = isConfigurationOverrides(arg1) ? arg1 : isConfigurationOverrides(arg2) ? arg2 : void 0;
        if (overrides) {
            if (overrides.resource) {
                configuration = this.configurationByRoot.findSubstr(overrides.resource.fsPath);
            }
        }
        configuration = configuration ? configuration : this.configuration;
        if (arg1 && typeof arg1 === 'string') {
            return getConfigurationValue(configuration, arg1);
        }
        return configuration;
    }

    public updateValue(key: string, overrides?: IConfigurationOverrides): Promise<void> {
        return Promise.resolve(null);
    }

    public setUserConfiguration(key: any, value: any, root?: URI): Thenable<void> {
        if (root) {
            const configForRoot = this.configurationByRoot.get(root.fsPath) || Object.create(null);
            configForRoot[key] = value;
            this.configurationByRoot.set(root.fsPath, configForRoot);
        } else {
            this.configuration[key] = value;
        }

        return Promise.resolve(null);
    }

    public onDidChangeConfiguration() {
        return { dispose() { } };
    }

    public inspect<T>(key: string, overrides?: IConfigurationOverrides): {
        default: T,
        user: T,
        workspace: T,
        workspaceFolder: T
        value: T,
    } {
        const config = this.getValue(undefined, overrides);

        return {
            value: getConfigurationValue<T>(config, key),
            default: getConfigurationValue<T>(config, key),
            user: getConfigurationValue<T>(config, key),
            workspace: null,
            workspaceFolder: null
        };
    }

    public keys() {
        return {
            default: getConfigurationKeys(),
            user: Object.keys(this.configuration),
            workspace: [],
            workspaceFolder: []
        };
    }

    public getConfigurationData() {
        return null;
    }
}